import { createTheme } from '@mui/material/styles';

const mainColor = '#E82B4B';
const mainColorLight = '#ff5c7a';
const mainColorLighter = '#ffb3c1';
const mainColorDark = '#b8002e';
const mainColorDarker = '#7a001e';

const accentColor = '#ff6a88';
const accentColorLight = '#ffb3c1';
const accentColorLighter = '#ffe0e6';
const accentColorDark = '#c13b5a';
const accentColorDarker = '#8a223a';

const secondaryColor = '#D32F2F';
const secondaryColorLight = '#ff6b6b';
const secondaryColorLighter = '#ffcdd2';
const secondaryColorDark = '#b71c1c';
const secondaryColorDarker = '#8e0000';

const white = '#fff';
const black = '#222';
const gray = '#666';

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: mainColor,
            light: mainColorLight,
            lighter: mainColorLighter,
            dark: mainColorDark,
            darker: mainColorDarker,
            contrastText: white,
        },
        secondary: {
            main: secondaryColor,
            light: secondaryColorLight,
            lighter: secondaryColorLighter,
            dark: secondaryColorDark,
            darker: secondaryColorDarker,
            contrastText: white,
        },
        accent: {
            main: accentColor,
            light: accentColorLight,
            lighter: accentColorLighter,
            dark: accentColorDark,
            darker: accentColorDarker,
            contrastText: white,
        },
        error: {
            main: '#d32f2f',
            contrastText: white,
        },
        warning: {
            main: '#e49e3d',
            contrastText: black,
        },
        info: {
            main: gray,
            contrastText: white,
        },
        success: {
            main: '#2F4F4F',
            contrastText: white,
        },
        background: {
            default: white,
            paper: white,
        },
        text: {
            primary: black,
            secondary: gray,
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: mainColor,
            light: mainColorLight,
            lighter: mainColorLighter,
            dark: mainColorDark,
            darker: mainColorDarker,
            contrastText: white,
        },
        secondary: {
            main: mainColor,
            light: mainColorLight,
            lighter: mainColorLighter,
            dark: mainColorDark,
            darker: mainColorDarker,
            contrastText: white,
        },
        accent: {
            main: accentColor,
            light: accentColorLight,
            lighter: accentColorLighter,
            dark: accentColorDark,
            darker: accentColorDarker,
            contrastText: white,
        },
        error: {
            main: '#d32f2f',
            contrastText: white,
        },
        warning: {
            main: '#e49e3d',
            contrastText: black,
        },
        info: {
            main: gray,
            contrastText: white,
        },
        success: {
            main: '#2F4F4F',
            contrastText: white,
        },
        background: {
            default: '#18191A',
            paper: '#23272F',
        },
        text: {
            primary: white,
            secondary: gray,
            main: gray
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
}); 